import { render, staticRenderFns } from "./DRItemReport.vue?vue&type=template&id=3cd10bc1&"
import script from "./DRItemReport.vue?vue&type=script&lang=js&"
export * from "./DRItemReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports